module.exports = __webpack_public_path__ + "img/folder-icon.6d35cb7d.svg";